<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto;">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px">
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">短信管理详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form ref="form" :model="data" :rules="rules" label-width="16rem" style="width: 80%;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="发送人" prop="Creater">
                <el-input v-model="data.Creater" disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发送日期" prop="SendTime">
                <el-date-picker
                  type="datetime"
                  style="width: 100%;"
                  placeholder="选择日期"
                  v-model="data.SendTime"
                  v-bind:disabled="true"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="发送内容" prop="Content">
                <el-input v-model="data.Content" disabled="true" type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="电话号码" prop="PhoneNo">
                <el-input v-model="data.PhoneNo" disabled="true" type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row><el-row>
            <el-col :span="24">
              <el-form-item label="接受人" prop="Extends2">
                <el-input v-model="data.Extends2" disabled="true" type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width:134rem;">
        <el-button @click="onBack()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";

export default {
  name: "SmsList",
  controller: "UI",
  action: "SmsDetail",
  data() {
    return {
      data: {}
    };
  },
  created: function() {
    if (this.$route.query.InfoId) {
      this.search();
    }
  },
  mounted: function() {},
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    }
  },
  methods: {
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        let searchInfo = {
          Id: InfoId,
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0
        };
        new MyApis.TranResourcesApi()
          .GetItemById(searchInfo)
          .then(r => {
            r = r.data.Data;
            console.log(r);
            this.data = r;
          })
          .catch(e => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    }
  }
};
</script>